import axios from "axios";

export const BASE_URL = `${process.env.REACT_APP_API_BASE}/LOGINREGISTRATION/api/v1`;
export const ENROLLMENT_URL = `${process.env.REACT_APP_API_BASE}/ENROLLMENTSERVICE/enrollments`;
export const INSTRUCTOR_URL = `${process.env.REACT_APP_API_BASE}/INSTRUCTORSERVICES/api/v1`;
export const COURSES_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api/v1`;
export const PAYMENTS_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api/v1/payments`;
export const CERTIFICATE_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api`;



const getAverageRatingByCourse = async(courseId) => {
  try{
    const response = await axios.get(`${COURSES_URL}/course/${courseId}/average-rating`);
    return response;
  } catch (error){
    throw error;
  }
}

export { getAverageRatingByCourse };

const deleteSection = async(courseId,sectionId,instructorId)=>{
  try{
    const response = await axios.delete(`${COURSES_URL}/course/${courseId}/${sectionId}?instructorId=${instructorId}`);
    return response;
  } catch (error){
    throw error;
  }
}

export {deleteSection};

const deleteLesson = async(courseId,sectionId,lessonId,instructorId) =>{
  try{
    const response = await axios.delete(`${COURSES_URL}/course/${courseId}/${sectionId}/${lessonId}?instructorId=${instructorId}`);
    return response;
  } catch (error){
    throw error;
  }
}

export {deleteLesson};

const runJavaProgram = async (data) => {

  try {
    const response = await axios.post(`${COURSES_URL}/run-code`, data, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error executing Code program:", error.response?.data || error.message);
    throw error.response?.data || "Failed to execute code";
  }
};

export { runJavaProgram };

const addSectionToCourse = async (courseId, formData, instructorId) => {
  console.log(formData);

  try {
    const response = await axios.put(
      `${COURSES_URL}/course/${courseId}/add-sections`, 
      formData, 
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: { instructorId },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export { addSectionToCourse };



export const addLessonToSection = async (courseId, sectionId, formData) => {
  try {
    const response = await axios.put(`${COURSES_URL}/course/${courseId}/${sectionId}/add-lesson`, formData);
    return response.data;
  } catch (error) {
    console.error('Error adding lesson:', error);
    throw error;
  }
}; 



const getInstructorEarningsByCourse = async(courseId) =>{

  try{
    const response = await axios.get(`${INSTRUCTOR_URL}/course/${courseId}/earnings`)
     return response;
  } catch (error){
    throw(error)
  }

}

export { getInstructorEarningsByCourse }

const coursesByInstructor = async(userId) =>{
  try{
    const response = await axios.get(`${COURSES_URL}/course/instructor/${userId}`)
     return response;
  } catch(error){
    throw(error)
  }
}

export { coursesByInstructor }

const createCourse = async(data) =>{
   try{
    const response = await axios.post(`${COURSES_URL}/course`,data);
     return response;
  } catch(error){
    throw error;
  }
};

export { createCourse };


const submitCourse = async(data) =>{

  try{
   const response = await axios.post(`${COURSES_URL}/course/submit`,data);
    return response;
 } catch(error){
   throw error;
 }
};

export {submitCourse};

const submitCourseForApproval = async (courseId) =>{
  try{
    const response = await axios.put(`${COURSES_URL}/course/${courseId}/submit`);
    return response;
  } catch (error){
    throw error;
  }
}

export {submitCourseForApproval}

const getCourseById = async (courseId) => {
  try{
    const response = await axios.get(`${COURSES_URL}/course/${courseId}`);
    return response;
  } catch(error){
    throw error
  }
};

export { getCourseById };



const register = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/register`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export { register };



const loginWithUserName = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/loginWithUserName`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export { loginWithUserName };

const forgetPassword = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}/forgot-password`, null, { params: { email } })
    return response;
  } catch (error) {
    throw error;
  }
}

export { forgetPassword };

const resetPassword = async (token,newPassword) => {
  try{
    const response = await axios.post(`${BASE_URL}/reset-password`,null,{params:{token,newPassword}});
    return response;
  }catch(error){
    throw error;
  }
}

export {resetPassword};
 
const profile = async (email) => {

  try{
    const response = await axios.get(`${BASE_URL}/profile`,email, {
      headers: {  
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }});
    return response;
  } catch(error){
    throw error;
  }
};


export { profile };

const profileUpdate = async (formData) => {
  try {
    console.log('Form data:', formData);

    const response = await fetch(`${BASE_URL}/profileUpdate`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',  
      },
      body: JSON.stringify(formData),
    });

 
    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error response:', errorData);
      throw new Error(errorData.message || 'Failed to update profile');
    }

    const data = await response.json();
     return data;
  } catch (error) {
    console.error('Error updating profile:', error.message);
    throw error;
  }
};

export { profileUpdate };
